<template>
  <v-row class="justify-center">
    <v-col
      cols="12"
      xs="12"
      sm="6"
      md="4"
      lg="3"
      class="d-flex align-stretch pa-1"
      v-if="tab == 1"
    >
      <v-card class="flex-grow-1">
        <v-card-subtitle class="title px-7">{{
          esquecisenha
            ? "Para criar uma nova senha preencha os campos abaixo"
            : "Olá, precisamos de algumas informações suas."
        }}</v-card-subtitle>
        <v-card-text class="text--primary pb-0">
          <v-form ref="activateForm1" lazy-validation>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                label="CPF"
                dense
                v-model="formData.cpf"
                :rules="$store.state.formRules.cpfRules"
                v-mask="'###.###.###-##'"
                outlined
              ></v-text-field>
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                label="Senha"
                dense
                :append-icon="show1 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show1 ? 'text' : 'password'"
                v-model="formData.senha"
                :rules="[$store.state.formRules.rulesPass.required]"
                @click:append="show1 = !show1"
                outlined
              ></v-text-field>
              <!-- :rules="[$store.state.formRules.rulesPass.required, $store.state.formRules.rulesPass.min]" -->
            </v-col>
            <v-col cols="12" class="pt-0 pb-0">
              <v-text-field
                label="Confirme a senha"
                dense
                :append-icon="show2 ? 'mdi-eye' : 'mdi-eye-off'"
                :type="show2 ? 'text' : 'password'"
                v-model="formData.confirmacao"
                :rules="[matchPass]"
                @click:append="show2 = !show2"
                outlined
              ></v-text-field>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="getUserData()">AVANÇAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      xs="12"
      sm="6"
      md="4"
      lg="3"
      class="d-flex align-stretch pa-1"
      v-if="tab == 2"
    >
      <v-card class="flex-grow-1">
        <v-card-subtitle class="title px-7"
          >Enviaremos um código de ativação.<br />
          Como gostaria de recebê-lo?</v-card-subtitle
        >
        <v-card-text class="text--primary pb-0">
          <v-form ref="activateForm2" lazy-validation>
            <v-col cols="12" class="pt-0 pb-0">
              <v-radio-group
                v-model="formData.codeSender"
                :mandatory="false"
                :rules="[$store.state.formRules.rulesPass.required]"
              >
                <v-radio
                  :label="masked.email"
                  value="email"
                  color="primary"
                ></v-radio>
                <p class="text-center">ou</p>
                <v-radio
                  :label="masked.telcelular"
                  value="sms"
                  color="primary"
                ></v-radio>
              </v-radio-group>
            </v-col>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="activationCode(true)"
            >ENVIAR CÓDIGO DE ATIVAÇÃO</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-col>
    <v-col
      cols="12"
      xs="12"
      sm="6"
      md="4"
      lg="3"
      class="d-flex align-stretch pa-1"
      v-if="tab == 3"
    >
      <v-card class="flex-grow-1">
        <v-card-subtitle class="title px-7"
          >Estamos quase lá.<br />
          Agora é só você inserir o código recebido.
        </v-card-subtitle>
        <v-card-text class="text--primary pb-0">
          <v-form ref="activateForm3" lazy-validation>
            <v-col cols="8" class="pt-0 pb-0 offset-2">
              <v-text-field
                class="text-center"
                label="Código de ativação"
                dense
                v-model="formData.codigoativacao"
                v-mask="'  #  #  #  #  '"
                :masked="false"
                :rules="$store.state.formRules.required"
                outlined
              ></v-text-field>
            </v-col>
          </v-form>
          <p>
            Ainda não recebeu?<br />
            <a href="" @click.prevent="activationCode(false)">Clique aqui</a>
            para reenviarmos o código para você.
          </p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" @click="activateUser()">ENVIAR</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>
  </v-row>
</template>
<script>
import { mapState } from "vuex";
import { mask } from "vue-the-mask";
export default {
  directives: {
    mask,
  },
  props: {
    errors: String,
  },
  data() {
    return {
      logo: {
        recoverPwd: "Recuperar senha",
        recoverPwdTxt:
          "O sistema irá enviar nova senha temporária para o endereço de email cadastrado.",
        restrictedarea: "Área restrita",
        src: "./assets/logo.png",
        title: "InSight Síndicos",
        txt: "Faça login para acessar o sistema.",
      },
      mask: "###.###.###-##",
      masked: {
        email: "",
        telcelular: "",
      },
      matchPass: (v) =>
        (!!v && v === this.formData.senha) || "A senha não confere",
      formData: {
        cpf: null,
        confirmacao: null,
        senha: null,
        codeSender: null,
        codigoativacao: null,
        email: null,
        telcelular: null,
      },
      show1: false,
      show2: false,
      validActivateForm1: true,
      validActivateForm2: true,
      validActivateForm3: true,
      validForm: true,
      tab: 1,
    };
  },
  computed: {
    ...mapState({
      formRules: (state) => state.formRules,
      esquecisenha: (state) => state.plans.esquecisenha,
    }),
  },
  methods: {
    async activationCode(firstSend) {
      let _this = this;
      let params = { ...this.formData, esquecisenha: this.esquecisenha };
      let valid = firstSend ? this.$refs.activateForm2.validate() : true;
      if (valid) {
        params.codeSender == "email"
          ? (params.telcelular = null)
          : (params.email = null);
        params.token = this.$store.state.tokenSms;
        await this.$store
          .dispatch("request/activationCode", params)
          .then((resp) => {
            if (resp.status >= 400) {
              this.$router.push("/login");
              return;
            }
            this.tab = 3;
          });
      }
    },
    async activateUser() {
      let _this = this;

      if (this.$refs.activateForm3.validate()) {
        let params = {
          cpf: this.formData.cpf,
          codigoativacao: this.formData.codigoativacao.replace(/\s/g, ""),
        };
        await this.$store
          .dispatch("request/activateUser", params)
          .then((resp) => {
            //console.log("www");
            if (resp.status >= 400) {
              this.$router.push("/login");
              return;
            }
            localStorage.kwTk = resp.kw;
            localStorage.corporeToken = resp.token;
            localStorage.corporeExpireToken =
              new Date().getTime() + 2 * 60 * 60 * 1000;
            localStorage.corporeUserId = params.cpf;
            setTimeout(() => {
              this.$router.push("/");
            }, 100);
            // this.$store.dispatch("request/getUserPlans", { token: resp.token, cpf: params.cpf })
          });
      }
    },
    async getUserData() {
      let cpf = this.formData.cpf;
      if (this.$refs.activateForm1.validate()) {
        await this.$store.dispatch("request/getUserData", cpf).then((resp) => {
          // console.log('passo2')
          if (resp) {
            this.formData.email = resp.email;
            this.formData.telcelular = resp.telcelular;
            this.maskEmail(this.formData.email);
            this.maskCellphone(this.formData.telcelular);
            this.tab = 2;
          }
        });
      }
    },
    maskEmail(email) {
      let emailArray = email.split("@");
      emailArray[0] = emailArray[0]
        .split("")
        .map((letter, ind) =>
          ind == 0 || ind == emailArray[0].length - 1 || letter == "."
            ? letter
            : "*"
        )
        .join("");
      this.masked.email = emailArray.join("@");
      return this.masked.email;
    },
    maskCellphone(number) {
      let ddd = number.substr(0, 2);
      let firstPart = number.substr(2, 4);
      let lastPart = number.substr(-1);

      this.masked.telcelular = `(${ddd}) ${firstPart}***-***${lastPart}`;
      return this.masked.telcelular;
    },
  },
};
</script>

<style>
.loginArea {
  max-width: 350px;
  margin: auto;
}
</style>
